import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import { getToken } from "./views/utils/authUtils";
import "./assets/css/global.css";
Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.prototype.$axios = axios;

router.beforeEach(function(to, from, next) {
  let token = getToken();
  if (to.path == "/login") {
    if (token) {
      this.$router.push("/home");
    } else {
      next();
    }
  } else {
    if (token) {
      next();
    } else {
      next({
        path: "/",
        query: { redirect: to.fullPath }
      });
    }
  }
});

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js